import type { ContentChatMode } from "./ContentChat";

/**
 * Сервер отдаёт ленту от новых к старым. Чат эфира так и читается, новое
 * первым; комментарии под видео наоборот, новое внизу, поэтому в режиме
 * video лента переворачивается.
 */
export function orderChatMessages<T>(
  messages: T[],
  mode: ContentChatMode,
): T[] {
  return mode === "stream" ? messages : [...messages].reverse();
}
